import api from './api';

// Helper para extrair dados da resposta
// NOTA: ReferenceHandler.Preserve foi removido da API
// Agora a API retorna arrays e objetos normais sem $values
const extractData = (data) => {
  // Se for um objeto com $values (legacy), extrair o array
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  // Retornar como está (array ou objeto)
  return data;
};

const professionalsService = {
  // Listar todos os profissionais (sempre retorna dados completos - BFF)
  getAll: async () => {
    const response = await api.get('/professionals');
    return extractData(response.data);
  },

  // Buscar profissional por ID
  getById: async (id) => {
    const response = await api.get(`/professionals/${id}`);
    return extractData(response.data);
  },

  // Criar novo profissional
  create: async (data) => {
    const response = await api.post('/professionals', data);
    return extractData(response.data);
  },

  // Atualizar profissional
  update: async (id, data) => {
    const response = await api.put(`/professionals/${id}`, data);
    return extractData(response.data);
  },

  // Deletar profissional
  delete: async (id) => {
    const response = await api.delete(`/professionals/${id}`);
    return extractData(response.data);
  },

  // ============================================
  // DEPRECATED METHODS - Use professionalServicePaymentsService
  // ============================================

  // ⚠️ DEPRECATED: Listar serviços de um profissional
  // USE: professionalServicePaymentsService.getByProfessionalId(professionalId)
  getServices: async (professionalId) => {
    console.warn('⚠️ DEPRECATED: professionalsService.getServices() - Use professionalServicePaymentsService.getByProfessionalId()');
    const response = await api.get(`/professionals/${professionalId}/services`);
    return extractData(response.data);
  },

  // ⚠️ DEPRECATED: Adicionar serviço a um profissional
  // USE: professionalServicePaymentsService.create(professionalId, data)
  addService: async (professionalId, serviceData) => {
    console.warn('⚠️ DEPRECATED: professionalsService.addService() - Use professionalServicePaymentsService.create()');
    const response = await api.post(`/professionals/${professionalId}/services`, serviceData);
    return extractData(response.data);
  },

  // ⚠️ DEPRECATED: Atualizar serviço
  // USE: professionalServicePaymentsService.update(professionalId, paymentId, data)
  updateService: async (professionalId, serviceId, serviceData) => {
    console.warn('⚠️ DEPRECATED: professionalsService.updateService() - Use professionalServicePaymentsService.update()');
    const response = await api.put(`/professionals/${professionalId}/services/${serviceId}`, serviceData);
    return extractData(response.data);
  },

  // ⚠️ DEPRECATED: Remover serviço
  // USE: professionalServicePaymentsService.delete(professionalId, paymentId)
  deleteService: async (professionalId, serviceId) => {
    console.warn('⚠️ DEPRECATED: professionalsService.deleteService() - Use professionalServicePaymentsService.delete()');
    const response = await api.delete(`/professionals/${professionalId}/services/${serviceId}`);
    return extractData(response.data);
  },
};

export default professionalsService;
